/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_CREATE
 */
export const issueSkimmerPairingCodeResponse = zod.object({
  "code": zod.string(),
  "issuedAt": zod.string().datetime({}),
  "rollsOverAt": zod.string().datetime({})
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_CREATE
 */
export const createSkimmerConnectionBody = zod.object({
  "prismaticInstanceId": zod.string(),
  "flows": zod.array(zod.object({
  "flow": zod.enum(['GetUsers', 'ListCompletions', 'GetDetail', 'GetWorkOrderTypes']),
  "url": zod.string(),
  "apiKey": zod.string()
}))
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const getSkimmerConnectionParams = zod.object({
  "id": zod.string().uuid()
})

export const getSkimmerConnectionResponse = zod.object({
  "flows": zod.object({
  "getUsersUrl": zod.string(),
  "listCompletionsUrl": zod.string(),
  "getDetailUrl": zod.string(),
  "getWorkOrderTypesUrl": zod.string()
}).optional()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const updateSkimmerConnectionParams = zod.object({
  "id": zod.string().uuid()
})

export const updateSkimmerConnectionBody = zod.object({
  "prismaticInstanceId": zod.string(),
  "flows": zod.array(zod.object({
  "flow": zod.enum(['GetUsers', 'ListCompletions', 'GetDetail', 'GetWorkOrderTypes']),
  "url": zod.string(),
  "apiKey": zod.string()
}))
})

export const updateSkimmerConnectionResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

